export default __webpack_public_path__ + "static/media/stake-more-srfuel.498b7565.svg";